import VinHiddenGroupScreen from './VinHiddenGroupScreen';
import ContractInfoHiddenDataViewer from './ContractInfoHiddenDataViewer';
export default {
  install: molten => {
    molten.addPlugin('DataViewer', {
      type: 'freeTextSearch',
      name: 'Hidden component',
      matches: [{
        objectType: 'vehicle'
      }, {
        objectType: 'sale'
      }, {
        objectType: 'case'
      }, {
        objectType: 'locator'
      }],
      location: 'hidden',
      handles: () => true,
      component: VinHiddenGroupScreen
    });
    molten.addPlugin('DataViewer', {
      type: 'contractInfoHiddenDataViewer',
      name: 'Contract info hidden data viewer component',
      matches: [{
        objectType: 'location'
      }],
      location: 'hidden',
      handles: () => true,
      component: ContractInfoHiddenDataViewer,
      id: 'recovr.contractInfoHiddenDataViewer'
    });
  }
};